export const bloggbtn = [
  {
    btnText: "অনুপ্রেরণা",
    link: "অনুপ্রেরণা",
  },
  {
    btnText: "কবিতা",
    link: "কবিতা",
  },
  {
    btnText: "ক্যাম্পেইন নিউজ",
    link: "ক্যাম্পেইন নিউজ",
  },
  {
    btnText: "প্রথম রক্তদান",
    link: "প্রথম-রক্তদান",
  },
  {
    btnText: "রক্ততথ্য",
    link: "রক্ততথ্য",
  },
  {
    btnText: "রক্তদানের-অভিজ্ঞতা",
    link: "রক্তদানের-অভিজ্ঞতা",
  },
  {
    btnText: "রক্তদানের-গল্প",
    link: "রক্তদানের-গল্প",
  },
  {
    btnText: "রক্তবন্ধু গ্যালারি",
    link: "রক্তবন্ধু-গ্যালারি",
  },
  {
    btnText: "সংবাদ",
    link: "সংবাদ",
  },
];
